import {React} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { Button, Grid, Switch, Typography } from "@material-ui/core";

import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../hooks/useForm";
import { validarSoloUnPermiso } from "../../../helpers/permisos";

const useStyles = makeStyles({
    botonera: {
        padding: 25
    },
    switchBase:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
              backgroundColor: '#3E8040',
              opacity: 1,
              border: 'none',
            },
          },
    },  
    TypographyRoot:{
        color:'gray',
        marginTop: "8px"
    }, 
    checked:{},
    track: {},
});

export const FormEspecialidades = (props) => {
    const classes = useStyles();
    const { especialidad, permisoEdit, permisoAlta } = props
    const { permisos: permisosUser } =  useSelector(state => state.auth)

    const FormInicial = {
        descripcionEspecialidades: "",
        edadMinima: 0,
        edadMaxima: 1,
        idEspecOs: 0,
    }
    const [formValues, handleInputChange, , setearValor] = useForm(especialidad ? especialidad : FormInicial);

    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues);
    };

    const handleChangeSwitch = (e) => {
        setearValor("mobile", e.target.checked);
    }
    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Descripción"
                        name="descripcionEspecialidades"
                        value={formValues.descripcionEspecialidades}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["La descripción es requerida"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextValidator
                        margin="normal"
                        label="Edad Mínima"
                        name="edadMinima"
                        value={formValues.edadMinima}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={['required', 'matchRegexp:^[0-9]+$']}
                        errorMessages={['La edad mínima es requerida', 'Solo se permiten números positivos enteros']}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextValidator
                        margin="normal"
                        label="Edad Máxima"
                        name="edadMaxima"
                        value={formValues.edadMaxima}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={['required', 'matchRegexp:^[0-9]+$', 'minNumber:1']}
                        errorMessages={['La edad máxima es requerida', 'Solo se permiten números positivos enteros', 'El valor mínimo es 1']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                </Grid>
                <Grid item xs={12} md={3}>
                <Typography className={classes.TypographyRoot}>Mostrar en MI OSPEDYC</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Switch
                        checked={formValues.mobile}
                        value={formValues.mobile}
                        name="mobile"
                        onChange={handleChangeSwitch}
                        classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                </Grid>
                <Grid container className={classes.botonera} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            {
                                (validarSoloUnPermiso(permisosUser, permisoAlta) || validarSoloUnPermiso(permisosUser, permisoEdit)) &&

                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                >
                                    GUARDAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    );
};

export default FormEspecialidades;